export const unitLabel = (u) => {
  if (!u) return "";
  const nome = u.denominazione_commerciale || u.codice || "";
  const sub = u.subalterno || (nome.match(/sub\.?\s*(\d{1,4})/i) || [])[1];
  const tipo = (nome.match(/\b(monolocale|bilocale|trilocale|quadrilocale|attico|box|cantina|negozio|ufficio|villetta|loft)\b/i) || [])[1];
  const parts = [sub ? `Sub ${sub}` : null, tipo ? tipo[0].toUpperCase() + tipo.slice(1).toLowerCase() : (u.tipologia && !sub ? nome : null)].filter(Boolean);
  const label = parts.length ? parts.join(" · ") : nome;
  const extra = [u.piano ? `piano ${u.piano}` : null, u.stato].filter(Boolean).join(", ");
  return extra ? `${label} (${extra})` : label;
};
